module.exports = vendor_f3471cea71432a5dee67;


//////////////////
// WEBPACK FOOTER
// external "vendor_f3471cea71432a5dee67"
// module id = 1
// module chunks = 0